// Global Layouts
// import layoutBox from './layoutBox' // kept for quick testing
import layoutHeader from './layoutHeader'
import layoutSidebar from './layoutSidebar'

// Colour Palettes
import paletteContrast from './paletteContrast'
import paletteDark from './paletteDark' // kept for quick testing
import paletteLight from './paletteLight'

// Custom
import gns3 from './gns3'
import mother from './mother'

const defaults = {
   // Global
   tmpBorderRadius: '4px',
   tmpBorderRadiusContainer: '4px',
   // Body - Text Style
   tmpBodyTextSize: '2',
   tmpBodyTextLineHeight: '150%',
   tmpSubBodyTextSize: '1.5[a-b] 1.5[c-f]',
   // Title - Text Styles
   tmpTitleXlSize: '8',
   tmpTitleLgLetterSpacing: '-0.5px',
   tmpTitleMdLetterSpacing: '-0.5px',
   // Title - Common Styles
   tmpTitleFontFamily: 'neue-haas-grotesk-text',
   tmpTitleTextTransform: 'none',
   // Notification Badge
   tmpNotificationBadgeColor: 'orange',
   tmpNotificationBadgeTextColor: '#111',
   // Unsorted Props - to be deprecated
   tmpNoteMetaTextColor: '#aaa',
   tmpNotePadding: '40px',
   tmpNoteMaxWidth: '600px',
   tmpBorderColor: '#eaeaea',
   tmpButtonTextColor: '#555',
   tmpContentTitleColor: '#111',
   tmpContentTextColor: '#211e1e',
   tmpCtaButtonHeight: '35px[a-d] 40px[e] 45px[f]',
   tmpNavTextColor: '#000',
   tmpTitlebarHeight: '15vh',
   tmpTitlebarMaxHeight: '90px[a-d] 100px[e] 110px[f]',
   tmpTitlebarMinHeight: '80px[a-d] 90px[e] 100px[f]',
   tmpTitleColor: '#111',
   tmpPrimaryButtonTextFontWeight: '500',
   tmpPrimaryButtonTextTransform: 'none',
   tmpViewMode: 'sidebar'
}

export default {
   _defaults: {
      ...defaults,
      ...layoutHeader,
      ...paletteLight
   },
   // TODO: Bring this back when Fuse can properly use bleeding edge
   // PR #701
   fuse: {
      ...defaults,
      ...layoutHeader,
      ...paletteContrast
   },
   gns3: {
      ...defaults,
      ...layoutHeader,
      ...paletteContrast,
      ...gns3
   },
   'mother-co': {
      ...defaults,
      ...layoutSidebar,
      ...paletteDark, // kept for quick testing until you can switch on client
      // ...paletteLight,
      // ...paletteContrast,
      ...mother
   },
   'ajay-sabhaney': {
      ...defaults,
      ...layoutSidebar,
      ...paletteLight
   },
   'steven-yuen': {
      ...defaults,
      ...layoutSidebar,
      ...paletteLight
   }
}
